import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import { useAddLocalTransportMutation } from "store/services/localTransportApi";
import LocalTransportForm from "./LocalTransportComponents/LocalTransportForm";

const LocalTransportCreateScreen = () => {
  const navigate = useNavigate();
  const [addLocalTransport, { isLoading }] = useAddLocalTransportMutation();

  const breadcrumbs = [
    { title: "Local Transports", path: "/app/crm/local-transport/list" },
    { title: "New Request" },
  ];

  const handleCreate = async (data) => {
    try {
      const res = await addLocalTransport(data).unwrap();
      const localTransportId = res?.data?._id;

      if (localTransportId) {
        toast.success(res?.message);

        navigate(`/app/crm/local-transport/${localTransportId}/detail`);
      } else {
        toast.warn("Request created, but missing ID in response.");
      }
    } catch (err) {
      toast.error(err?.data?.message || "Failed to create request.");
    }
  };

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={isLoading}>
      <BreadcrumbLayout.Paper>
        <LocalTransportForm isBusy={isLoading} onSubmit={handleCreate} />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default LocalTransportCreateScreen;
